import axios from 'axios';
export const getSpecializations = async () => {
  const response = await axios.get(`/admin-config/specializations`);
  return response;
};

export const createSpecialization = async (specialization_description) => {
  const response = await axios.post(`/admin-config/specializations`, {
    specialization_description
  });
  return response;
};

export const updateSpecialization = async (specialization) => {
  const response = await axios.put(`/admin-config/specializations/${specialization.id}`, {
    specialization_description: specialization.specialization_description
  });

  return response;
};
